import styled from 'styled-components';
import { Row } from 'antd';

export default styled(Row)`
  flex-grow: 1;
  display: flex;
`;
